module.exports = __webpack_public_path__ + "static/media/overview_up.07ceaf5d.svg";